import { getInnerError, renderLoader } from 'app/lib/utils/adaya/AdayaUtils';
import axios from 'axios';
import Button from 'components/shared/app/Button';
import Spinner from 'components/shared/app/Spinner';
import Config from 'lib/Config';
import GoogleService from 'lib/services/providers/GoogleService';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import './style.scss';

const GoogleCallback = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [callbackData, setCallbackData] = useState({});
    const [customerValue, setCustomerValue] = React.useState('');
    const [dataSaved, setDataSaved] = useState(false);

    const handleChange = (event) => {
        setCustomerValue(event.target.value);
    };

    const handleClick = async (event) => {
        try {
            setLoading(true);
            setError(undefined);

            let lci = callbackData.customers.find(x => {
                console.log(x.customer);
                return x.customer.id.toString() === customerValue
            });

            // console.log(`callbackData`, callbackData);

            let r = await GoogleService.connectGoogleAccount({
                email: callbackData.email,
                access_token: callbackData.credentials.tokens.access_token,
                refresh_token: callbackData.credentials.tokens.refresh_token,
                googleEmail: callbackData.email,
                customer: customerValue,
                login_customer_id: lci.login_customer_id
            });

            if (r.success) {
                await props.auth.updateUserLocal(r.user);
                setDataSaved(true);
            } else {
                setError(getInnerError(r));
            }

        } catch (e) {
            setError(getInnerError(e));
        }

        setLoading(false);
    };

    const goToAccountButton = () => {
        return (
            <Link to="/account">
                <Button round filled color="green">
                    Go To Account
                </Button>
            </Link>
        );
    };

    const customerSelectDropdown = () => {
        const sortCustomers = (a, b) => {
            let aId = `${a.customer.descriptive_name || a.customer.id}`;
            let bId = `${b.customer.descriptive_name || b.customer.id}`;
            return (aId < bId) ? -1 : (aId > bId) ? 1 : 0;
        }

        return (
            <>
                <h5 style={{ color: '#fff', margin: '1rem' }}>Please select the Google Ads account:</h5>
                <select onChange={handleChange}>
                    <option>Select..</option>
                    {callbackData.customers.sort(sortCustomers).map((c, i) => (
                        <option key={i} value={c.customer.id}>{c.customer.descriptive_name ? c.customer.descriptive_name : c.customer.id}</option>
                    ))}
                </select>{' '}
                <br />
                <Button round filled color="green" onClick={handleClick}>
                    Select Ads Account
                </Button>
            </>
        );
    };

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            let code = window.location.search;
            const r = await axios.get(`${process.env.API_URL}/googleads-callback${code}`);

            if (r.data.success) {
                if (r.data.customers.length == 0) {
                    setError('You have no eligible Google Ads accounts for ' + r.data.email)
                }
                else
                    setCallbackData(r.data);
            } else {

                console.log(`error`, r);
                setError(
                    (r.error || r.message || 'An error occurred connecting your Google account.') +
                    ' Please return to the Account page and try again.');
            }
        } catch (e) {
            throw e;
        }
        setLoading(false);
    };

    const renderError = () => (
        <div className="flex-col-center error">
            <h3>Error</h3>
            <h4 dangerouslySetInnerHTML={{ __html: error }}></h4>
            <p>Please try to connect your Google account again from the Account page.</p>
            <Link to="/account">
                <div className="button color-green filled round">Back to Account</div>
            </Link>
        </div>
    );

    return (
        <div className="google-callback-page">
            <Helmet>
                <title>{Config.SITE_TITLE_PREFIX} - Connecting Google Account</title>
            </Helmet>

            {
                error ? renderError() :

                    loading ? renderLoader('Connecting to Google...') :

                        (
                            <div className="flex-col-center" style={{ marginTop: '4rem', width: '100%' }}>
                                {loading ? (
                                    <Spinner message="Loading customer information..." />
                                ) : (
                                    <>
                                        <Helmet>
                                            <title>{Config.SITE_TITLE_PREFIX} - Google Connected</title>
                                        </Helmet>
                                        <h4 style={{ color: '#fff', margin: '1rem' }}>Thank you for connecting your Google account!</h4>

                                        {dataSaved ? goToAccountButton() : customerSelectDropdown()}
                                    </>
                                )}
                            </div>
                        )
            }

        </div>
    );

};

export default GoogleCallback;
